import { IconMail, IconMessage, IconPhoneCall } from "@tabler/icons-react";
import AppContext from "Context/appContext";
import Card from "components/Card";
import FormInput from "components/FormInput";
import "containers/ContactDetails";
import "containers/ContactDetails/index.css";
import { useContext, useEffect, useState, useCallback } from "react";
import { Controller, useFormState } from "react-hook-form";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

const ContactDeatils = () => {
  const {
    formdata,
    setFormData,
    productCartDetail,
    progressState,
    setErrors,
    reactHookFormData,
    countryDetails,
    isWebView,
    setNotificationWay,
    isButtonClicked,
    userSettings
  } = useContext(AppContext);

  const { register, handleSubmit, watch, control, formErrors } =
    reactHookFormData;
  const [menuOption, setMenuOption] = useState([
    {
      id: 1,
      name: "SMS Text (Instant)",
      icon: <IconMessage className="quote-contact-icon" />,
      value: "sms",
      active: false,
    },
    {
      id: 2,
      name: "Email (Instant)",
      icon: <IconMail className="quote-contact-icon" />,
      value: "email",
      active: false,
    },
    {
      id: 3,
      name: "Phone",
      icon: <IconPhoneCall className="quote-contact-icon" />,
      value: "phone",
      active: false,
    },
  ]);


  // Get the current form errors from useFormState
  const { errors } = useFormState({ control: control });

  const updateStatus = (index) => {
    const selectedItem = menuOption[index];
    menuOption.filter((m) => {
      if (m.id === selectedItem.id) {
        m.active = true;
      } else {
        m.active = false;
      }
    });
    
    const optionValue = selectedItem.active ? selectedItem.value : "";
    setFormData({
      ...formdata,
      option: optionValue,
    });
    
    // Update react-hook-form value for option field
    reactHookFormData.setValue("option", optionValue);
    
    // Trigger validation when any card option is clicked
    if (reactHookFormData.trigger) {
      reactHookFormData.trigger();
    }
  };

  const updateFields = (index) => {
    // Update checkbox state immediately, before validation
    const selectedItem = menuOption[index];

    // Create a new array to update the checkbox state
    const updatedMenuOption = menuOption.map((m, idx) => ({
      ...m,
      active: idx === index, // Set active to true only for the clicked item
    }));

    // Filter out any non-serializable data (like React components) before storing
    const serializableMenuOption = updatedMenuOption.map(
      ({ id, name, value, active }) => ({
        id,
        name,
        value,
        active, // Only keep serializable data
      })
    );

    // Save the serializable version of the state in localStorage
    sessionStorage.setItem(
      "menuOption",
      JSON.stringify(serializableMenuOption)
    );

    // Update the checkbox state first
    setMenuOption(updatedMenuOption);

    // Update the form data to reflect the selected option
    setFormData({
      ...formdata,
      option: selectedItem.value,
    });
    
    // Update react-hook-form value for option field
    reactHookFormData.setValue("option", selectedItem.value);

    setNotificationWay(selectedItem.value);

    // No validation triggered here; it's deferred to the button click event

    // Now trigger validation (this will show errors, but not stop checkbox update)
    // handleSubmit(() => {
    //   // Validation logic here
    //   console.log("Validation passed");
    // })(); // Immediately invoke handleSubmit to trigger validation
  };

  // Manually add the `icon` back if needed after loading from storage
  const restoreOptionField = () => {
    const storedMenuOption = sessionStorage.getItem("menuOption");
    if (storedMenuOption) {
      const parsedMenuOption = JSON.parse(storedMenuOption);
      const updatedMenuOption = parsedMenuOption.map((option) => ({
        ...option,
        icon: (() => {
          switch (option.value) {
            case "sms":
              return <IconMessage className="quote-contact-icon" />;
            case "email":
              return <IconMail className="quote-contact-icon" />;
            default:
              return <IconPhoneCall className="quote-contact-icon" />;
          }
        })(),
      }));
      setMenuOption(updatedMenuOption); // Restore state from sessionStorage
    }
  };

  // Detect web view on component mount
  useEffect(() => {
    // handleSubmit(() => {})(); // Immediately invoke handleSubmit to trigger validation

    // Only restore state when the component mounts (i.e., on tab reopen)
    restoreOptionField();

    const handleBeforeUnload = () => {
      sessionStorage.removeItem("menuOption"); // Clear only when the tab is closed or refreshed
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      // Optionally clear sessionStorage on component unmount
      window.removeEventListener("beforeunload", handleBeforeUnload); // Clean up the event listener
    };
  }, []);

  const submitHandler = (data) => {
    // Trigger validation when form is submitted
    if (reactHookFormData.trigger) {
      reactHookFormData.trigger();
    }
  };

  // Trigger validation when all required fields are filled to ensure buttons work
  useEffect(() => {
    const hasAllRequiredFields = 
      (formdata.firstName || formdata.lastName) && 
      formdata.phone && 
      formdata.email && 
      formdata.option;
    
    if (hasAllRequiredFields && reactHookFormData.trigger) {
      // Trigger validation to update the validation state
      reactHookFormData.trigger();
    }
  }, [formdata.firstName, formdata.lastName, formdata.phone, formdata.email, formdata.option, reactHookFormData.trigger]);

  // Watch form values and update formdata
  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      if (type === "change" && name) {
        setFormData((prev) => ({
          ...prev,
          [name]: value[name],
        }));
        
        // Trigger validation when any field changes
        // if (reactHookFormData.trigger) {
        //   reactHookFormData.trigger();
        // }
      }
    });
    
    return () => subscription.unsubscribe();
  // }, [watch, setFormData, reactHookFormData]);
  }, [watch, setFormData]);

  useEffect(() => {
    menuOption.forEach((m) => {
      m.active = false;
    });
  }, []);

  return (
    <div className="quote-colum rd-quote-w-full quote-scroller-hide md:rd-quote-w-[75%] quote-scroll-contact-details">
      <div className="rd-quote-mb-4">
        <form
          className="quote-contact-form"
          onSubmit={handleSubmit(submitHandler)}
        > 
          <div className="rd-quote-flex quote-direction-column rd-quote-flex-wrap lg:rd-quote-gap-x-5 xs:rd-quote-pl-3 xs:rd-quote-pr-3 lg:rd-quote-pl-0 lg:rd-quote-pr-6 xs:rd-quote-pt-3 md:rd-quote-pt-4">
            {/* for mobile screens */}
            {!isWebView && (
              <p className="quote-text2">
                How do you want your quote delivered?
                <span className="rd-quote-text-red-500 rd-quote-text-sm rd-quote-font-medium rd-quote-font-['SF Pro Text'] rd-quote-leading-tight">
                  *
                </span>
              </p>
            )}
            {!isWebView && (
              <div 
                className="rd-quote-mt-3 rd-quote-flex rd-quote-flex-col rd-quote-mb-4"
                style={{
                  '--checkbox-color': userSettings?.colourHex?.buttonAndBorderColor || '#ebebeb'
                }}
              >
                {menuOption.map((e, index) => (
                  <div
                    key={e.name}
                    className={`rd-quote-flex rd-quote-items-center !rd-quote-gap-x-2
                      ${e.value === "sms" &&
                        (countryDetails?.country !== "Australia" &&
                          countryDetails?.country !== "United States" &&
                          countryDetails?.country !== "Canada" &&
                          countryDetails?.country !== "United Kingdom")
                          ? 'rd-quote-pointer-events-none rd-quote-opacity-50'
                          : ''}
                      `}
                  >
                    <input
                      type="checkbox"
                      value={e.value}
                      checked={e.active}
                      onChange={() => updateFields(index)}
                    />
                    <icon className="rd-quote-text-gray-500">{e.icon}</icon>
                    <label>{e.name}</label>
                  </div>
                ))}
              </div>
            )}

            {productCartDetail?.skipForOthers && progressState === 4 && (
              <label className="quote-text2">
                <span> Model </span>
                <span className="rd-quote-text-red-500 rd-quote-text-sm rd-quote-font-medium rd-quote-font-['SF Pro Text'] rd-quote-leading-tight">
                  *
                </span>
                <FormInput
                  register={register}
                  name="model"
                  placeholder="Enter Model"
                />
                {errors?.model?.message && (
                  <p className="rd-quote-text-red-500 rd-quote-mt-1">
                    {errors.model.message}
                  </p>
                )}
              </label>
            )}
            <label className="quote-text2">
              <span> First Name </span>
              {/* <span className="rd-quote-text-red-500 rd-quote-text-sm rd-quote-font-medium rd-quote-font-['SF Pro Text'] rd-quote-leading-tight">
                *
              </span> */}

              <FormInput
                register={register}
                name="firstName"
                placeholder="Enter First Name"
              />

              {/* {errors?.firstName?.message && (
                <p className="rd-quote-text-red-500 rd-quote-mt-1">
                  {errors.firstName.message}
                </p>
              )} */}
            </label>

            <label className="quote-text2">
              <span> Last Name </span>
              {/* <span className="rd-quote-text-red-500 rd-quote-text-sm rd-quote-font-medium rd-quote-font-['SF Pro Text'] rd-quote-leading-tight">
                *
              </span> */}

              <FormInput
                register={register}
                name="lastName"
                placeholder="Enter Last Name"
              />

              {/* {((isButtonClicked && !isWebView) || isWebView) && (
                <p className="rd-quote-text-red-500 rd-quote-mt-1">
                  {errors?.lastName?.message}
                </p>
              )} */}
            </label>

            {/* Show name validation error */}
            {errors?.nameRequired && (
              <p className="rd-quote-text-red-500 rd-quote-mt-1 rd-quote-mb-2">
                {errors.nameRequired.message}
              </p>
            )}

            <label className={`quote-text2 quote-instant-form-width`}>
              <span> Phone </span>
              <span className="rd-quote-text-red-500 rd-quote-text-sm rd-quote-font-medium rd-quote-font-['SF Pro Text'] rd-quote-leading-tight">
                *
              </span>

              <Controller
                control={control}
                name="phone"
                render={({ field: { onChange, value } }) => (
                  <PhoneInput
                    international
                    defaultCountry={countryDetails?.country_code}
                    value={value}
                    onChange={(phoneValue) => {
                      onChange(phoneValue);
                      setFormData(prev => ({
                        ...prev,
                        phone: phoneValue
                      }));
                    }}
                    countrySelectProps={{
                      tabIndex: -1,
                      style: {
                        pointerEvents: 'none',
                        cursor: 'default',
                        userSelect: 'none'
                      }
                    }}
                    countryCallingCodeEditable={false}
                    className="rd-quote-mt-2 quote-border-styling phone-field-width rd-quote-py-2 rd-quote-pl-3 rd-quote-font-normal md:rd-quote-mt-2 rd-quote-rounded-md focus:rd-quote-outline-none rd-quote-ring-0 focus:rd-quote-border-none focus:rd-quote-ring-0 rd-quote-placeholder-gray-400 rd-quote-text-gray-700 rd-quote-text-sm rd-quote-w-full rd-quote-h-[40px]"
                  />
                )}
              />

              {errors?.phone?.message && (
                <p className="rd-quote-text-red-500 rd-quote-mt-1">
                  {errors.phone.message}
                </p>
              )}
            </label>

            <label className="quote-text2 quote-margin-top-mid-large-screen">
              <span> Email </span>
              <span className="rd-quote-text-red-500 rd-quote-text-sm rd-quote-font-medium rd-quote-font-['SF Pro Text'] rd-quote-leading-tight">
                *
              </span>

              <FormInput
                register={register}
                name="email"
                placeholder="Enter Email"
                type="email"
              />

              {errors?.email?.message && (
                <p className="rd-quote-text-red-500 rd-quote-mt-1">
                  {errors.email.message}
                </p>
              )}
            </label>
          </div>

          <label className="quote-colum rd-quote-text-gray-700 rd-quote-font-medium rd-quote-text-[16px] lg:rd-quote-mt-2 xs:rd-quote-pl-3 xs:rd-quote-pr-3 lg:rd-quote-pl-0 lg:rd-quote-pr-6">
            <span> Notes </span>
            <textarea
              placeholder="Describe the issue you are facing with your device"
              name="notes"
              {...register("notes")}
              className="rd-quote-border rd-quote-py-2 rd-quote-pl-3 rd-quote-font-normal rd-quote-mt-2 rd-quote-border-gray-300 rd-quote-rounded-md rd-quote-shadow  focus:rd-quote-outline-none rd-quote-ring-0 focus:rd-quote-ring-0 rd-quote-placeholder-gray-400 rd-quote-text-gray-700 rd-quote-text-sm rd-quote-w-full rd-quote-mr-1"
            />
          </label>

          {/* for screens (tablet and laptop) */}
          {isWebView && (
            <p className="quote-text2 rd-quote-mt-5 rd-quote-pl-0 rd-quote-pr-6">
              How would you like us to share the update?
              <span className="rd-quote-ml-0.5 rd-quote-text-red-500 rd-quote-text-sm rd-quote-font-medium rd-quote-font-['SF Pro Text'] rd-quote-leading-tight">
                *
              </span>
            </p>
          )}
          {isWebView && (
            <div className="lg:rd-quote-pr-6 lg:rd-quote-pb-6 rd-quote-grid rd-quote-grid-cols-1 md:rd-quote-grid-cols-3 md:rd-quote-grid-flow-col rd-quote-gap-4 quote-alignment-center quote-card-grid md:rd-quote-mt-3">
              {menuOption.map((p, index) => (
                <Card
                  key={p.id}
                  product={p}
                  Icon={p.icon}
                  index={index}
                  filteredProducts={updateStatus}
                />
              ))}
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default ContactDeatils;
